module.exports = __webpack_public_path__ + "static/shield-f57b9bcd3a35ee12d02b34f69711c827.png";